const tokenManager = {
  // Get token from storage
  getToken: (): string | null => {
    try {
      return localStorage.getItem("token");
    } catch (error) {
      console.warn("Failed to get token from local storage", error);
      return null;
    }
  },

  // Set token in storage
  setToken: (token: string | null): void => {
    try {
      if (token) {
        localStorage.setItem("token", token);
      } else {
        localStorage.removeItem("token");
      }
    } catch (error) {
      console.warn("Failed to set token in local storage", error);
    }
  },

  removeToken: (): void => {
    try {
      localStorage.removeItem("token");
    } catch (error) {
      console.warn("Failed to remove token from storage", error);
    }
  },

  hasToken: (): boolean => {
    return !!tokenManager.getToken();
  },
};

export default tokenManager;
